const _ = require('lodash');
const qs = require('qs');

// this function is ONLY used in index.jsx and propably doesnt belong in this file
const ensureDataTypesInQuerySpecification = querySpecification => {
  const result = {
    ...querySpecification,
  };

  if (_.isArray(querySpecification)) {
    return querySpecification.map(ensureDataTypesInQuerySpecification);
  }

  const querySpecificationKeys = Object.keys(querySpecification);
  for (let i = 0; i < querySpecificationKeys.length; i++) {
    const key = querySpecificationKeys[i];
    const currentValue = querySpecification[key];
    if (_.isObject(currentValue)) {
      result[key] = ensureDataTypesInQuerySpecification(currentValue);
    } else if (_.isBoolean(currentValue)) {
      result[key] = currentValue;
    } else if (!Number.isNaN(Number(currentValue))) {
      result[key] = +currentValue;
    } else if (currentValue === 'true' || currentValue === 'false') {
      result[key] = currentValue === 'true';
    }
  }

  return result;
};

const ensureNextQuery = nextQuery => {
  const parsedQuery = qs.parse(nextQuery);
  const querySpecification = ensureDataTypesInQuerySpecification(
    parsedQuery.query || {},
  );
  return { ...parsedQuery, query: querySpecification };
};

// TODO this should be refactored when all shops are using orqueries only
// the or checkes are for lists or queries. This will be redunant and should be
// refactored when all shops have retired single query object

const isSubsetOfQuerySpecification = (querySpecifications, subsetQuery) =>
  _.every(subsetQuery.or, orQuery =>
    _.some(querySpecifications.or, querySpecification =>
      _.every(orQuery, (x, key) => _.isEqual(x, querySpecification[key])),
    ),
  );

const countQueryOverlap = (querySpecification, subsetQuery = {}) => {
  if (
    subsetQuery.or.length > 1 ||
    Object.keys(querySpecification.or).length > 1
  ) {
    return 1;
  }
  const query = subsetQuery.or[0];
  const keys = Object.keys(query);

  let count = 0;
  for (let i = 0; i < keys.length; i++) {
    const key = keys[i];
    if (_.isEqual(query[key], querySpecification.or[0][key])) {
      count++;
    }
  }
  return count;
};

const getQuerySpecification = (nextQueryObject, querySpecification) => {
  if (nextQueryObject.querySpecification) {
    if (
      _.isString(nextQueryObject.querySpecification) &&
      nextQueryObject.querySpecification[0] === '{'
    ) {
      // this is needed due to how nextjs handles query params client side vs server side
      return ensureDataTypesInQuerySpecification(
        JSON.parse(nextQueryObject.querySpecification),
      );
    }

    return ensureDataTypesInQuerySpecification(
      qs.parse(nextQueryObject.querySpecification),
    );
  }
  if (nextQueryObject.filter && _.includes(nextQueryObject.filter, '=')) {
    return ensureDataTypesInQuerySpecification(
      qs.parse(nextQueryObject.filter),
    );
  }
  if (_.isArray(querySpecification.or)) {
    return querySpecification;
  }
  const ret = ensureDataTypesInQuerySpecification(querySpecification);

  return ret;
};

module.exports = {
  ensureDataTypesInQuerySpecification,
  isSubsetOfQuerySpecification,
  countQueryOverlap,
  getQuerySpecification,
  ensureNextQuery,
};
